import { atom } from 'jotai'
import { IAccount } from '../types'

type IProfileState = IAccount | null

const defaultState: IProfileState = null

// base atom with initial value
export const profileAtom = atom<IProfileState>(defaultState)